import MediaItem from "./MediaItem";
import {__} from "../util/dom";

export default class MediaLibrary {
    static registerDefaultMediaItemGenerator(generator) {
        this.generator = generator;
    }

    static getGenerator(possibleGenerator) {
        const generator = possibleGenerator || this.generator;
        
        if(!generator) {
            return media => new MediaItem(media);
        }

        return generator;
    }

    static load(selector, mediaItemGenerator) {
        MediaLibrary.list = [];
        MediaLibrary.keyList = {};

        // lookup via the dom
        Array.from(__(selector)).forEach(
            media => MediaLibrary.register(media, mediaItemGenerator)
        );
    }

    static get(key) {
        return MediaLibrary.keyList[key];
    }

    static register(media, possibleGenerator) {
        const generator = MediaLibrary.getGenerator(possibleGenerator);
        const mediaItem = generator(media);
        MediaLibrary.list.push(mediaItem);
        MediaLibrary.keyList[mediaItem.key] = mediaItem;
    }
}